const SDK_VERSION = '8.7.0';

export { SDK_VERSION };
//# sourceMappingURL=version.js.map
